import { ThemeOptions, Typography } from "@mui/material";
import { createTheme, ThemeProvider, Paper } from "@mui/material";

const ThemeColors = {
  paperBackground: "rgba(242, 242, 243, 0.45)",
  textBody: "#595856",
  textDark: "#000000",
  textAction: "#618888",
  textDisabled: "#979695",
  textHeadings: "#302E2C",
  textInformation: "#00F",

  warning: "#E37A41",
  warning100: "#FDF2EC",

  confidenceMedium: "#FFE300",
  confidenceMediumEmpty: "#FFF6B5",

  metaforaGreen: "#396A6A",

  primaryBackground100: "#ECF1F1",
};

export default ThemeColors;
